import { store } from '@/store/store'
import Vue from 'vue'
import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_GESCON_SEF_URL}${process.env.VUE_APP_API_PATH}`

export default {
    ListarConvenios() {
        return axiosJwt
            .get(`${api}/gescon/financeiro/convenio/ListarConveniosFinanceiro`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    ObterConvenioPorId(id) {
        return axiosJwt
            .get(`${api}/gescon/financeiro/convenio/ObterConvenioPorId/${id}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    ListarPrestacoesContas(idConvenio) {
        return axiosJwt
            .get(`${api}/gescon/financeiro/convenio/ListarPrestacoesMensais/${idConvenio}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    // EnviarPrestacaoMensal(idPrestacaoMensal) {
    //     return axiosJwt.post(`${api}/gescon/gestor/convenio/enviarprestacaomensal/${idPrestacaoMensal}`)
    //         .then((response) => {
    //             return response.data
    //         }).catch((error) => {
    //             return errorHandler(error)
    //         })
    // },

    ObterPrestacaoMensal(id) {
        return axiosJwt
            .get(`${api}/gescon/financeiro/convenio/ObterPrestacaoMensal/${id}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    // InserirPrestacaoMensal(prestacao) {
    //     return axiosJwt.post(`${api}/gescon/gestor/convenio/InserirPrestacaoMensal`, prestacao)
    //         .then((response) => {
    //             return response.data
    //         }).catch((error) => {
    //             return errorHandler(error)
    //         })
    // },

    // ExcluirPrestacaoMensal(id) {
    //     return axiosJwt
    //         .get(`${api}/gescon/gestor/convenio/ExcluirPrestacaoMensal/${id}`)
    //         .catch(error => {
    //             return errorHandler(error)
    //         })
    // },

    ListarPrestacoesFinais(idPrestacaoMensal) {
        return axiosJwt
            .get(`${api}/gescon/financeiro/convenio/ListarPrestacoesFinais/${idPrestacaoMensal}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    // ListarAcoes(idConvenio) {
    //     return axiosJwt
    //         .get(`${api}/gescon/gestor/convenio/ListarAcoes/${idConvenio}`)
    //         .then(response => {
    //             return response.data
    //         })
    //         .catch(error => {
    //             return errorHandler(error)
    //         })
    // },

    // ListarNaturesasPorAcoes(idConvenio, idAcao) {
    //     return axiosJwt
    //         .get(`${api}/gescon/gestor/convenio/ListarNaturesasPorAcoes/${idConvenio}/${idAcao}`)
    //         .then(response => {
    //             return response.data
    //         })
    //         .catch(error => {
    //             return errorHandler(error)
    //         })
    // },

    // InserirPrestacaoFinal(prestacao) {
    //     return axiosJwt.post(`${api}/gescon/gestor/convenio/InserirPrestacaoFinal`, prestacao)
    //         .then((response) => {
    //             return response.data
    //         }).catch((error) => {
    //             return errorHandler(error)
    //         })
    // },

    // AtualizarPrestacaoFinal(prestacao) {
    //     return axiosJwt.post(`${api}/gescon/gestor/convenio/AtualizarPrestacaoFinal`, prestacao)
    //         .then((response) => {
    //             return response.data
    //         }).catch((error) => {
    //             return errorHandler(error)
    //         })
    // },

    // ExcluirPrestacaoFinal(id) {
    //     return axiosJwt
    //         .get(`${api}/gescon/gestor/convenio/ExcluirPrestacaoFinal/${id}`)
    //         .catch(error => {
    //             return errorHandler(error)
    //         })
    // },

    ListarDocumentosPrestacaoFinal(idPrestacaoFinal) {
        return axiosJwt
            .get(`${api}/gescon/financeiro/convenio/ListarDocumentosPrestacoesFinais/${idPrestacaoFinal}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterTiposDocumentos() {
        return axiosJwt
            .get(`${api}/gescon/financeiro/convenio/ListarTiposDocumentos`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    ObterImpostos() {
        return axiosJwt
            .get(`${api}/gescon/financeiro/convenio/impostos`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    // inserirDocumentosPrestacaoFinal(documento) {
    //     const formData = new FormData()
    //     formData.append('id_Documento', documento.id_Documento)
    //     formData.append('id_Convenio', documento.id_Convenio)
    //     formData.append('idPrestacaoContasFinal', documento.idPrestacaoContasFinal)
    //     formData.append('id_TipoDocumento', documento.id_TipoDocumento)
    //     formData.append('vcDescricaoDocumento', documento.vcDescricaoDocumento)
    //     formData.append('vcNomeArquivo', documento.vcNomeArquivo)
    //     formData.append('arquivo', documento.arquivo)

    //     return axiosJwt.post(`${api}/gescon/gestor/convenio/InserirDocumentoConvenio`, formData, {
    //         headers: {
    //             'Content-Type': 'multipart/form-data'
    //         }
    //     })
    //         .then((response) => {
    //             return response.data
    //         }).catch((error) => {
    //             return errorHandler(error)
    //         })
    // },

    // ExcluirDocumentoConvenio(id) {
    //     return axiosJwt
    //         .get(`${api}/gescon/gestor/convenio/ExcluirDocumentoConvenio/${id}`)
    //         .catch(error => {
    //             return errorHandler(error)
    //         })
    // },

    downloadDocumento(id) {
        return axiosJwt
            .get(
                `${api}/gescon/financeiro/convenio/DownloadDocumentoPorId/${id}`,
                {
                    responseType: 'blob'
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterRelatorio(idConvenio, relatorio) {
        return axiosJwt
            .get(`${api}/gescon/financeiro/convenio/${idConvenio}/relatorios/${relatorio}`, { responseType: 'blob' })
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    ObterAcoesPlanoTrabalho(idConvenio) {
        return axiosJwt
            .get(`${api}/gescon/financeiro/convenio/obteracoesplanotrabalho/${idConvenio}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    // inserirAcaoPlanoTrabalho(acao) {
    //     return axiosJwt.post(`${api}/gescon/gestor/convenio/inseriracaoplanotrabalho`, acao)
    //         .then((response) => {
    //             return response.data
    //         }).catch((error) => {
    //             return errorHandler(error)
    //         })
    // },

    // cancelarAcaoPlanoTrabalho(id) {
    //     return axiosJwt
    //         .get(`${api}/gescon/gestor/convenio/cancelaracaoplanotrabalho/${id}`)
    //         .then(response => {
    //             return response.data
    //         })
    //         .catch(error => {
    //             return errorHandler(error)
    //         })
    // },

    // alterarAcaoPlanoTrabalho(acao) {
    //     return axiosJwt.post(`${api}/gescon/gestor/convenio/alteraracaoplanotrabalho`, acao)
    //         .then((response) => {
    //             return response.data
    //         }).catch((error) => {
    //             return errorHandler(error)
    //         })
    // },

    obterEventosPorAcao(id) {
        return axiosJwt
            .get(`${api}/gescon/financeiro/convenio/acaoplanotrabalho/${id}/eventos`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    // cancelarEvento(id) {
    //     return axiosJwt
    //         .get(`${api}/gescon/gestor/convenio/cancelarevento/${id}`)
    //         .then(response => {
    //             return response.data
    //         })
    //         .catch(error => {
    //             return errorHandler(error)
    //         })
    // },

    // inserirEvento(evento) {
    //     return axiosJwt.post(`${api}/gescon/gestor/convenio/inserirevento`, evento)
    //         .then((response) => {
    //             return response.data
    //         }).catch((error) => {
    //             return errorHandler(error)
    //         })
    // },

    // alterarEvento(evento) {
    //     return axiosJwt.post(`${api}/gescon/gestor/convenio/alterarevento`, evento)
    //         .then((response) => {
    //             return response.data
    //         }).catch((error) => {
    //             return errorHandler(error)
    //         })
    // },

    obterDocumentosEvento(idEvento) {
        return axiosJwt
            .get(`${api}/gescon/financeiro/convenio/obterdocumentosevento/${idEvento}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    // inserirDocumentoEvento(documento) {
    //     const formData = new FormData()
    //     formData.append('idEvento', documento.idEvento)
    //     formData.append('vcNomeArquivo', documento.vcNomeArquivo)
    //     formData.append('arquivo', documento.arquivo)
    //     formData.append('descricaoArquivo', documento.descricaoArquivo)
    //     return axiosJwt.post(`${api}/gescon/gestor/convenio/inserirdocumentoevento`, formData, {
    //         headers: { 'Content-Type': 'multipart/form-data' }})
    //         .then((response) => {
    //             return response.data
    //         }).catch((error) => {
    //             return errorHandler(error)
    //         })
    // },

    // excluirDocumentoEvento(idDocumentoEvento) {
    //     return axiosJwt
    //         .get(`${api}/gescon/gestor/convenio/excluirdocumentoevento/${idDocumentoEvento}`)
    //         .then(response => {
    //             return response.data
    //         })
    //         .catch(error => {
    //             return errorHandler(error)
    //         })
    // },

    downloadDocumentoEvento(idEvento, idDocumento) {
        return axiosJwt
            .get(`${api}/gescon/financeiro/convenio/downloaddocumentoevento/${idEvento}/${idDocumento}`, { responseType: 'blob' })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterMetas(idEvento) {
        return axiosJwt
            .get(`${api}/gescon/financeiro/convenio/${idEvento}/obtermetas`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    // cancelarMeta(id) {
    //     return axiosJwt
    //         .get(`${api}/gescon/gestor/convenio/cancelarmeta/${id}`)
    //         .then(response => {
    //             return response.data
    //         })
    //         .catch(error => {
    //             return errorHandler(error)
    //         })
    // },

    // inserirMeta(meta) {
    //     return axiosJwt.post(`${api}/gescon/gestor/convenio/inserirmeta`, meta)
    //         .then((response) => {
    //             return response.data
    //         }).catch((error) => {
    //             return errorHandler(error)
    //         })
    // },

    obterTiposInstrumento() {
        return axiosJwt
            .get(`${api}/gescon/financeiro/convenio/obtertiposinstrumento`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterGestores() {
        return axiosJwt
            .get(`${api}/gescon/financeiro/convenio/gestores`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterUnidades() {
        return axiosJwt
            .get(`${api}/gescon/financeiro/convenio/unidades`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
}
